import { Main } from './general-responses.model';
import { Priority } from './priority.model';
import { ProjectsList } from './projects.model';
import { Status } from './status.model';
import { User } from './user.model';

export interface RequisitionResponse extends Main {
  response: RequisitionData | UsersWho | RequisitionFilters | Requisition;
}

export interface RequisitionData {
  limit: number;
  page: number;
  total: number;
  rows: Requisition[];
}

export interface RequisitionItemsResponse extends Main {
  response: Requisition;
}

export interface RequisitionUserResponse {
  userWhoApproves: User[];
  userWhoBuys: User[];
  userWhoReviews: User[];
}

export interface Requisition {
  createdAt: string;
  createByUser: User;
  updateAt: string;
  updateByUser: User;
  reviewed: boolean;
  isRejected: boolean;
  isCanceled: boolean;
  requisitionId: number;
  requisitionKey: string;
  requisitionDescription: string;
  requisitionApplicationDate: string;
  requisitionExpectedDeliveryDate: string;
  requisitionFolio: number;
  requisitionIsHighlighted: boolean;
  requisitionNotes: string;
  requisitionStatus: Status;
  requisitionProgress?: Status;
  requisitionLabelState: string;
  requisitionPriority: Priority;
  project: ProjectsList;
  userWhoAuthorizes: User;
  userWhoRequests: User;
  userWhoBuys: User;
  userWhoReviews: User;
  dimLink: string;
  items: ItemRequisition[];
  totalCost: number;
  onSchedule: boolean;
  userWhoAuthorizesId?: number;
  userWhoBuysId?: number;
  userWhoReviewsId?: number;
  field?: string;
  rejectedReason?: string;
  canceledReason?: string;
  rejectedInfo?: RejectedInfo;
  canceledInfo?: CancelledInfo;
}

export interface RejectedInfo {
  rejectedBy: User;
  rejectedReason: string;
  rejectedDate: string;
}

export interface CancelledInfo {
  canceledBy: User;
  canceledReason: string;
  canceledDate: string;
}

export interface ItemRequisition {
  itemId: number;
  parentId: number;
  resourceId: number;
  resourceName: string;
  resourceDescription: string;
  resourceUnit: string;
  componentId: number;
  componentName: string;
  componentType: null;
  itemQuantity: number;
  itemNotes: string;
  productionUnitId: number;
  productionUnitName: string;
  componentResourceId: number;
}

export interface SelectableRequisition {
  requisitionId: number;
  requisitionDescription: string;
  isSelected: boolean;
  isIdTooltipVisible: boolean;
  isFolioTooltipVisible: boolean;
}

export interface UsersWho {
  userWhoAuthorizes: User[];
  userWhoBuys: User[];
  userWhoReviews: User[];
  userWhoRequests: User[];
}

export interface RequisitionFilters {
  priorities: string[];
  states: string[];
  progress: string[];
  expectedDeliveryDate?: string[];
  applicationDate?: string[];
  idFilter?: string;
  folioFilter?: string;
  descriptionFilter?: string;
  projectFilter?: string;
  usersFilter?: {
    userWhoAuthorizes: number[];
    userWhoBuys: number[];
    userWhoReviews: number[];
    userWhoRequests: number[];
  };
}

export interface RequisitionColumn {
  title: string;
  name?: string;
  isVisible?: boolean;
  hasShowAndHideColumnFilter?: boolean;
  hasSearchFilter?: boolean;
  hasSelectableFilter?: boolean;
  hasDateFilter?: boolean;
  isSortable?: boolean;
  width: string;
  align?: string;
}

export enum RequisitionColumnEnum {
  UserWhoRequests = 0,
  RequisitionKey = 1,
  RequisitionFolio = 2,
  RequisitionDescription = 3,
  RequisitionProject = 4,
  RequisitionApplicationDate = 5,
  RequisitionExpectedDeliveryDate = 6,
  TotalCost = 7,
  UserWhoBuys = 8,
  UserWhoAuthorizes = 9,
  UserWhoReviews = 10,
  RequisitionPriority = 11,
  RequisitionStatus = 12,
  RequisitionProgress = 13,
  Actions = 14,
}

export enum DashboardRequisitionColumnEnum {
  UserWhoRequests = 0,
  RequisitionFolio = 1,
  RequisitionDescription = 2,
  RequisitionProject = 3,
  RequisitionApplicationDate = 4,
  RequisitionExpectedDeliveryDate = 5,
  TotalCost = 6,
  UserWhoAuthorizes = 7,
  RequisitionPriority = 8,
  RequisitionStatus = 9,
  RequisitionProgress = 10,
}

export enum RequisitionStatusEnum {
  'Editando',
  'Terminada',
  'Revisada',
  'Autorizado',
  'Cancelada',
  'Rechazada',
  'Vencida',
  'En proceso de compra',
  'Comprado',
  'Entregado'
}

export enum RequisitionProgressEnum {
  'Iniciado',
  'En espera de revisión',
  'En espera de autorizar',
  'Enviado a compras',
  'En proceso de compra',
  'Comprada',
  'En proceso de entrega',
  'Vencida',
  'Entregada',
  'Rechazada',
  'Cancelada',
}
